import template from './flow-sidebar-section.html';

export default angular
  .module('app.holding.dashboard.flow')
  .directive('holdingFlowSidebarSection', holdingFlowSidebarSection)
  .name;

function holdingFlowSidebarSection() {
  'ngInject';

  return {
    link,
    replace: true,
    restrict: 'E',
    template,
    transclude: true,
  };

  function link(scope, _elem, attrs) {
    scope.header = attrs.header || '';
    scope.subHeader = attrs.subHeader || '';

    attrs.$observe('header', (newVal, oldVal) => {
      if (newVal !== oldVal) {
        scope.header = newVal;
      }
    });

    attrs.$observe('subHeader', (newVal, oldVal) => {
      if (newVal !== oldVal) {
        scope.subHeader = newVal;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/flow/directives/flow-sidebar-section/flow-sidebar-section.js